// extracted by mini-css-extract-plugin
module.exports = {"parentBox":"DynamicBanner_parentBox__I4YGD","child1":"DynamicBanner_child1__ZD0h1","child2":"DynamicBanner_child2__47rr5","child3":"DynamicBanner_child3__ADV8u"};